import adminMock from './admin-mock';

var req = function req(context) {
  return context.keys().map(context);
};

var options = req(require.context('./api/', true, /\.js$/)).filter(function (e) {
  return e.default;
}).map(function (e) {
  return e.default;
});
options.forEach(function (option) {
  typeof adminMock.load === 'function' && adminMock.load(option);
});